<template>
  <div class="screen flex-column" data-theme="greenDark">
    <Header title="卓创资讯炼油行业运行监测系统"></Header>
    <router-view></router-view>
  </div>
</template>

<script>
import Header from "./components/header/Header";
export default {
  name: 'Entry',
  components:{
    Header
  },
  data() {
    return {
    }
  },
  created(){
    window.document.documentElement.setAttribute( "data-theme", 'green' );
  },
  watch: {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.screen{
    min-height: 100vh;
    background:url('~@/view/template_02/assets/images/body_bg.jpg') no-repeat;
    background-size: 100% 100%;
  }
</style>
<style lang="scss">
$--color-primary: #36cacf;
/* 改变 icon 字体路径变量，必需 */
$--font-path: '~element-ui/lib/theme-chalk/fonts';
@import "~element-ui/packages/theme-chalk/src/index";
</style>